import React from 'react';
import { styled } from '@mui/material/styles';
import { Container, Typography, useMediaQuery } from '@mui/material';
import SectionTitle from '../../../../components/SectionTitle';
import PsgPrize from '../../../../assets/images/psg-prize.png';
import PsgPrizeMobile from '../../../../assets/images/psg-prize-mobile.png';

const IntroductionRoot = styled('div')(({ theme }) => ({
    backgroundColor: '#F8F9FA',
    padding: '50px 0',
    textAlign: 'center',
}));

const PrizeImage = styled('img')(({ theme }) => ({
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
    margin: '20px auto',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
    [theme.breakpoints.up('md')]: {
        width: '60%',
    },
    [theme.breakpoints.up('lg')]: {
        width: '55%',
    },
}));

const Introduction = () => {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <IntroductionRoot>
            <Container maxWidth="lg">
                <SectionTitle subtitle="PSG Think Forward Conference" hideArrow={true} />

                <Typography variant="h5">Win a RoboVac with CIA Ninja</Typography>

                <PrizeImage src={isMobile ? PsgPrizeMobile : PsgPrize} alt="PSG Prize" />

                <Typography variant="body1" marginY={2}>
                    Submit your details below to be entered into our daily draw for a Xiaomi S20
                    RoboVacuum valued at over R4,000. Winners will be contacted at the end of each
                    conference day. Be on the lookout for an email with further details about how to
                    win the main prize valued at R12,000
                </Typography>
            </Container>
        </IntroductionRoot>
    );
};

export default Introduction;
